/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Button, Space, Select, Typography } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CourseContestsManagementModal from "./ContestManagementModal";
import CourseLectureFeedbackModal from "./CourseLectureFeedbackModal";
import CourseReminderGraphModal from "./CourseReminderStatsModal";
import CreateCourseModal from "./CreateCourseModal";
import CourseFeedbackModal from "./FeedbackDetailsModal";
import SalesStatsModal from "./SalesStatsModal";
import CourseUsersModal from "./SubscribersModal";
import { COURSE_MANAGEMENT_ROUTE_PREFIX } from "../../constants/routes";
import {
  showErrorNotification,
  showNotification,
  showSuccessNotification
} from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";

const CoursesDash = ({ adminConfig = {}, ROOT_URL }) => {
  const [displayName, setDisplayName] = useState("");
  const [activeInfoCourseId, setActiveInfoCourseId] = useState("");

  const [selectedBatch, setSelectedBatch] = useState();
  const [courseList, setCourseList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [isCreateEditCourseModalOpen, setIsCreateEditCourseModalOpen] = useState(false);

  const [courseReminderStatsModalOpen, setCourseReminderStatsModalOpen] = useState(false);
  const [courseReminderStats, setCourseReminderStats] = useState([]);
  const [courseReminderCount, setCourseReminderCount] = useState(0);

  const [courseFeedbackModalOpen, setCourseFeedbackModalOpen] = useState(false);
  const [courseFeedbackDetails, setCourseFeedbackDetails] = useState({});

  const [isSalesDetailsModalOpen, setIsSalesDetailsModalOpen] = useState(false);
  const [salesStats, setSalesDetails] = useState({});

  const [isSubscriptionListingOpen, setIsSubscriptionListingOpen] = useState(false);
  const [isCourseLectureFeedbackModalOpen, setIsCourseLectureFeedbackModalOpen] = useState(false);
  const [isContestManagementModalOpen, setIsContestManagementModalOpen] = useState(false);

  const [courseTypes, setCourseTypes] = useState([]);
  const [batchesInfo, setBatchesInfo] = useState([]);
  const [coursesList, setCoursesList] = useState([]);
  const [saleStatusesList, setSaleStatusesList] = useState([]);

  const fetchCoursesList = () => {
    axios
      .get(`${ROOT_URL}/admin/courses/list`, {
        params: {
          batch: selectedBatch
        }
      })
      .then((res) => {
        const { courses } = res.data;
        setCourseList(courses);
        showSuccessNotification("Course List Fetched Successfully");
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const handleCreateCourseFormReq = () => {
    axios
      .get(`${ROOT_URL}/admin/courses/form-requisites`, {})
      .then((res) => {
        const { courseTypes: validCourseTypes, coursesList, batchesList, saleStatuses } = res.data;
        setCourseTypes(validCourseTypes);
        setBatchesInfo(batchesList);
        setCoursesList(coursesList);
        setSaleStatusesList(saleStatuses);
        if (batchesList.length > 0) {
          setSelectedBatch(batchesList[batchesList.length - 1].label);
        }
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const handleCreateEditCourse = (formInput) => {
    if (initialValues?.key !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/courses/update`, {
          courseParams: formInput,
          courseId: initialValues.key
        })
        .then(() => {
          setIsCreateEditCourseModalOpen(false);
          showSuccessNotification("Course Updated Successfully");
          fetchCoursesList();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/create`, {
          courseParams: formInput
        })
        .then(() => {
          setIsCreateEditCourseModalOpen(false);
          showSuccessNotification("Course Created Successfully");
          fetchCoursesList();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const fetchCourseReminderStats = (courseId) => {
    axios
      .get(`${ROOT_URL}/admin/courses/reminder-stats`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        setCourseReminderStats(res.data?.courseReminderStats);
        setCourseReminderCount(res.data?.totalReminders);
        showSuccessNotification("Course Reminder Stats successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchCourseFeedback = (courseId) => {
    axios
      .get(`${ROOT_URL}/admin/courses/feedback-details`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        const { questionAggregate, additionalComments, feedbackCount } = res.data;
        setCourseFeedbackDetails({ additionalComments, questionAggregate, feedbackCount });
        showSuccessNotification("Feedback Details Fetched successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchSalesStats = (courseId) => {
    axios
      .get(`${ROOT_URL}/admin/courses/sales-stats`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        const {
          totalPayments,
          discountedPaymentCount,
          totalPaymentVolume,
          totalDiscountGiven,
          paymentCountStats
        } = res.data;
        setSalesDetails({
          totalPayments,
          discountedPaymentCount,
          totalPaymentVolume,
          totalDiscountGiven,
          paymentCountStats
        });
        setIsSalesDetailsModalOpen(true);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchCourseDetailsForEdit = (courseId) => {
    axios
      .get(`${ROOT_URL}/admin/courses/details-for-edit`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        const { courseDetails } = res.data;
        setIsEdit(true);
        setInitialValues(courseDetails);
        setIsCreateEditCourseModalOpen(true);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index",
      width: 70
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 260,
      render: (name, row) => {
        return (
          <>
            <p>{name}</p>
            <b>Internal Name:</b> {row.displayName} <br />
            <b>URL Identifier:</b> {row.urlIdentifier} <br />
            <b>UI Display:</b> {row.uiDisplayName} <br />
            <b>Descendant Course:</b> {row.descendantCourse} <br />
          </>
        );
      }
    },
    {
      title: "Price Details (in INR)",
      dataIndex: "price",
      key: "price",
      width: 200,
      render: (price, row) => {
        return (
          <>
            <p>
              <b>Price:</b> {price}
            </p>
            <p>
              <b>Doubt Support Ext Price:</b> {row.doubtSupportExtensionPrice}
            </p>
          </>
        );
      }
    },
    {
      title: "Sale Status",
      dataIndex: "saleStatus",
      key: "saleStatus",
      width: 130
    },
    {
      title: "Paid Purchases",
      dataIndex: "purchases",
      key: "purchases",
      width: 130
    },
    {
      title: "Slots",
      dataIndex: "slotCap",
      key: "slotCap",
      width: 90
    },
    {
      title: "Actions",
      key: "action",
      width: 260,
      render: (row) => (
        <div
          id="course_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              {adminConfig?.courses?.hasCriticalInfoAccess && (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      fetchCourseReminderStats(row.key);
                      setCourseReminderStatsModalOpen(true);
                      setActiveInfoCourseId(row.key);
                    }}
                  >
                    Course Reminder Stats
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      fetchSalesStats(row.key);
                    }}
                  >
                    Sales Stats
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      fetchCourseFeedback(row.key);
                      setCourseFeedbackModalOpen(true);
                    }}
                  >
                    Feedback
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      setActiveInfoCourseId(row.key);
                      setIsCourseLectureFeedbackModalOpen(true);
                    }}
                  >
                    Lectures Feedback
                  </Button>
                </>
              )}
              {adminConfig?.courses?.hasSubscriptionViewAccess && (
                <Button
                  type="primary"
                  onClick={() => {
                    setActiveInfoCourseId(row.key);
                    setDisplayName(row.displayName);
                    setIsSubscriptionListingOpen(true);
                  }}
                >
                  View Subscriptions
                </Button>
              )}
              {adminConfig?.courses?.hasManageAccess && (
                <>
                  {!row.config.isModuleBasedContentManagementSupported && (
                    <>
                      <Button
                        type="primary"
                        onClick={() => {
                          window.open(COURSE_MANAGEMENT_ROUTE_PREFIX + `?id=${row.key}`, "_blank");
                        }}
                      >
                        Manage Course
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          setActiveInfoCourseId(row.key);
                          setIsContestManagementModalOpen(true);
                        }}
                      >
                        Manage Contests
                      </Button>
                    </>
                  )}

                  {adminConfig?.courses?.hasCourseSaleControlAccess && (
                    <Button
                      type="primary"
                      onClick={() => {
                        fetchCourseDetailsForEdit(row.key);
                      }}
                    >
                      Edit Course Details
                    </Button>
                  )}
                </>
              )}
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    if (selectedBatch) {
      fetchCoursesList();
    }
  }, [selectedBatch]);

  useEffect(() => {
    handleCreateCourseFormReq();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px"
        }}
      >
        {adminConfig?.courses?.hasCreateAccess && (
          <Button
            type="primary"
            onClick={() => {
              setIsEdit(false);
              setInitialValues({});
              setIsCreateEditCourseModalOpen(true);
            }}
          >
            Create Course
          </Button>
        )}
      </div>
      <Typography.Text>Please select a batch to view courses.</Typography.Text>
      <br />
      <Select
        placeholder="Select Batch"
        style={{ width: "min(200px, 100%)", marginBottom: 10 }}
        value={selectedBatch}
        onChange={(value) => {
          setSelectedBatch(value);
        }}
      >
        {(batchesInfo || []).map((item) => (
          <Select.Option value={item.label} key={item.key}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
      <Table
        columns={columns}
        dataSource={courseList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isSubscriptionListingOpen === true && (
        <CourseUsersModal
          courseId={activeInfoCourseId}
          displayName={displayName}
          isModalOpen={isSubscriptionListingOpen}
          setIsModalOpen={setIsSubscriptionListingOpen}
          ROOT_URL={ROOT_URL}
        />
      )}
      {isCreateEditCourseModalOpen === true && (
        <CreateCourseModal
          isModalOpen={isCreateEditCourseModalOpen}
          setIsModalOpen={setIsCreateEditCourseModalOpen}
          courseTypes={courseTypes}
          coursesList={coursesList}
          batchesInfo={batchesInfo}
          saleStatusesList={saleStatusesList}
          isEdit={isEdit}
          initialValues={initialValues || {}}
          handleCreateEditCourse={handleCreateEditCourse}
          ROOT_URL={ROOT_URL}
        />
      )}
      {courseReminderStatsModalOpen === true && (
        <CourseReminderGraphModal
          isModalOpen={courseReminderStatsModalOpen}
          setIsModalOpen={setCourseReminderStatsModalOpen}
          courseReminderStats={courseReminderStats}
          courseReminderCount={courseReminderCount}
          courseId={activeInfoCourseId}
          ROOT_URL={ROOT_URL}
        />
      )}
      {courseFeedbackModalOpen === true && (
        <CourseFeedbackModal
          isModalOpen={courseFeedbackModalOpen}
          setIsModalOpen={setCourseFeedbackModalOpen}
          questionsRatingObj={courseFeedbackDetails.questionAggregate}
          additionalCommentsList={courseFeedbackDetails.additionalComments}
          feedbackCount={courseFeedbackDetails.feedbackCount}
        />
      )}
      {isSalesDetailsModalOpen === true && (
        <SalesStatsModal
          isModalOpen={isSalesDetailsModalOpen}
          setIsModalOpen={setIsSalesDetailsModalOpen}
          salesStats={salesStats}
        />
      )}
      {isCourseLectureFeedbackModalOpen === true && (
        <CourseLectureFeedbackModal
          isModalOpen={isCourseLectureFeedbackModalOpen}
          setIsModalOpen={setIsCourseLectureFeedbackModalOpen}
          currentCourseId={activeInfoCourseId}
          ROOT_URL={ROOT_URL}
        />
      )}
      {isContestManagementModalOpen === true && (
        <CourseContestsManagementModal
          isModalOpen={isContestManagementModalOpen}
          setIsModalOpen={setIsContestManagementModalOpen}
          courseId={activeInfoCourseId}
          ROOT_URL={ROOT_URL}
        />
      )}
    </div>
  );
};

export default CoursesDash;
